import "./../css/style.scss";
import $ from 'jquery';

const replaceHmrLinks = () => {
    const links = document.querySelectorAll("[href]:not(link),[action]");
    links.forEach(link => {
        if (link?.href) {
            link.href = replaceToHmrLink(link.href);
        }
        if (link?.action) {
            link.action = replaceToHmrLink(link.action);
        }
    });
}
const replaceToHmrLink = (link) => {
    return link.replace(window.location.origin.replace(":8080", ""), window.location.origin)
}

if (module.hot) {
    replaceHmrLinks();
    module.hot.accept();
}

$(document).ready(function () {
    console.log("DOCUMENT IS READY");
});

